'use client'

import Image from 'next/image'

export default function Control({ theme, playing, handlePrev, handlePlay, handleNext, handlePause }) {
  return (
    <article className="block-control flex justify-between">
      <button onClick={handlePrev} id="J_btnPrev">
        <Image
          src={`/svg/prev-${theme.split('-')[1] || ''}.svg`}
          alt="previous"
          width={26}
          height={26}
        />
      </button>

      <button
        onClick={handlePause}
        id="J_btnPause"
        className={`${playing ? '' : 'hidden'}`}
      >
        <Image
          src={`/svg/pause-${theme.split('-')[1] || ''}.svg`}
          alt="pause music"
          width={66}
          height={66}
        />
      </button>
      <button
        onClick={handlePlay}
        id="J_btnPlay"
        className={`${playing ? 'hidden' : ''}`}
      >
        <Image
          src={`/svg/play-${theme.split('-')[1] || ''}.svg`}
          alt="play music"
          width={66}
          height={66}
        />
      </button>

      <button onClick={handleNext} id="J_btnNext">
        <Image
          src={`/svg/next-${theme.split('-')[1] || ''}.svg`}
          alt="next"
          width={26}
          height={26}
        />
      </button>
    </article>
  )
}